module.exports = __webpack_public_path__ + "static/media/family-compressed.0dd81c07.jpg";